import { render } from "./InputChoice.vue?vue&type=template&id=4be1b0d2"
import script from "./InputChoice.vue?vue&type=script&lang=js"
export * from "./InputChoice.vue?vue&type=script&lang=js"

import "./InputChoice.vue?vue&type=style&index=0&id=4be1b0d2&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__